import React, { useState, useRef } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import './NumericTerminal.sass'

interface Props {
  submit: () => void
  value: string
  setValue: (val: string) => void
}

const NumericTerminal: React.FC<Props> = ({
  submit,
  value,
  setValue,
}) => {
  const keyboard = useRef<any>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const handleInternalSubmit = async () => {
    setIsSubmitting(true);
    try {
      await submit(); 
    } finally {
      setIsSubmitting(false); 
    }
  };

  const onKeyPress = (button: string) => {
    if (isSubmitting) return;

    if (button === 'OK') {
      handleInternalSubmit();
      return;
    }
  
    if (button === '{bksp}') {
      setValue(value.slice(0, -1));
      return;
    }

    if (!/^\d$/.test(button)) return;
    if (value.length >= 10) return;

    let newValue = value + button;
    if (newValue.length === 2 || newValue.length === 5) {
      newValue += ".";
    }
    setValue(newValue);
  };

  return (
    <div className="numeric-terminal" onClick={(e) => e.stopPropagation()}>
      <Keyboard
        keyboardRef={(r) => (keyboard.current = r)}
        onKeyPress={onKeyPress}
        layout={{
          default: ["1 2 3", "4 5 6", "7 8 9", "{bksp} 0 OK"],
        }}
        preventMouseDownDefault={true}
        display={{
          "{bksp}": "⌫",
          "OK": "OK"
        }}
        buttonTheme={[
          {
            class: "btn-green",
            buttons: "OK"      
          },
        ]}
        theme={"hg-theme-default hg-layout-numeric numeric-theme"}
      />
    </div>
  );
};

export default NumericTerminal